import script from "./WUserDetailSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WUserDetailSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./WUserDetailSidebar.vue?vue&type=style&index=0&id=e71c5808&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e71c5808"]])

export default __exports__